module.exports = __webpack_public_path__ + "img/upload-bottom.53c2e823.svg";